import { render, staticRenderFns } from "./KeyboardSvg.vue?vue&type=template&id=105a3813&scoped=true&"
import script from "./KeyboardSvg.vue?vue&type=script&lang=js&"
export * from "./KeyboardSvg.vue?vue&type=script&lang=js&"
import style0 from "./KeyboardSvg.vue?vue&type=style&index=0&id=105a3813&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "105a3813",
  null
  
)

export default component.exports